import { FilterList } from '@/interfaces/haggle/FilterList.enum';

const filterSwitch = (filterQuery: string) => {
	switch (filterQuery) {
		case FilterList.FINISHED:
			return { 'filterQuery[status]': 'finished' };
		case FilterList.ACTIVE:
			return { 'filterQuery[status]': 'active' };
		case FilterList.PENDING:
			return { 'filterQuery[status]': 'pending' };
		case FilterList.MIN_MARGIN:
			return { 'sort[acceptableMargin]': 'ASC' };
		case FilterList.MAX_MARGIN:
			return { 'sort[acceptableMargin]': 'DESC' };
		case FilterList.NEWEST:
			return { 'sort[createdAt]': 'DESC' };
		case FilterList.OLDEST:
			return { 'sort[createdAt]': 'ASC' };
		default:
			return;
	}
};

export default filterSwitch;
